import { axios } from '@axios';
import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from '../../lib/react-query';

export const getErrorLogs = (params: any): Promise<any> => {
  return axios.get('/admin/error-logs', { params });
};

type QueryFnType = typeof getErrorLogs;

export const useErrorLogsQuery = ({ params, config }: { params: any; config?: QueryConfig<QueryFnType> }) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['errorLogs', params],
    queryFn: () => getErrorLogs(params),
    select: (res: any) => res,
    ...config,
  });
};